import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo + Name */}
        <a href="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/f5d6660d-0404-49ec-a2ea-dec9e29f0147.png"
            alt="カーサービス田中自動車 ロゴ"
            className="h-10 w-auto object-contain"
          />
          <span
            className={`font-bold text-lg whitespace-nowrap transition-colors duration-300 ${
              scrolled ? 'text-gray-800' : 'text-white'
            }`}
          >
            カーサービス田中自動車
          </span>
        </a>

        {/* Right Info */}
        <div className="flex items-center gap-6">
          <div
            className={`hidden md:flex items-center gap-4 text-sm transition-colors duration-300 ${
              scrolled ? 'text-gray-600' : 'text-white/90'
            }`}
          >
            <div className="flex items-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-time-line text-sm" />
              </div>
              <span>月〜土 8:00〜18:00｜日・祝 定休</span>
            </div>
          </div>
          <a
            href="tel:0000000000"
            className={`flex items-center gap-2 font-bold text-base whitespace-nowrap transition-colors duration-300 ${
              scrolled ? 'text-green-600' : 'text-white'
            }`}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-base" />
            </div>
            000-000-0000
          </a>
        </div>
      </div>
    </header>
  );
}
